import SiteHeader from "../modules/site-header";

export default () => {
    const nodeSelectors = {
        container: '[js-site-nav-mobile="container"]',
        opener: '[js-site-nav-mobile="opener"]',
        background: '[js-site-nav-mobile="background"]',
    }

    const openNavTl = gsap.timeline({
        paused: true
    });

    const closeNavTl = gsap.timeline({
        paused: true,
    });

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        openNavTl.to(document.querySelector(nodeSelectors.container), {display: 'block', duration: 0.01}, 0)
            .to(document.querySelector(nodeSelectors.container), {opacity: 1, duration: 0.01}, 0)
            .to(document.querySelector(nodeSelectors.background), {height: '100%', duration: 0.5, ease: "power2.in"}, 0)
            .to(document.querySelector(nodeSelectors.container).querySelectorAll('.content'), {opacity: 1, duration: 0.5, ease: "power2.in"}, 0.4)
            .to(document.querySelector(nodeSelectors.container).querySelectorAll('nav li'), {opacity: 1, duration: 0.6, stagger: 0.025, ease: "power2.in"}, 0.4)

        closeNavTl.to(document.querySelector(nodeSelectors.container), {opacity: 0, duration: 0.2}, 0)
            .to(document.querySelector(nodeSelectors.container), {display: 'none', duration: 0}, 0.3)

        // Close mobile nav on Esc key press
        jQuery(document).keyup(function(e) {
            if (e.key === "Escape") {
                close();
            }
        });

        // Open/Close mobile nav
        jQuery(nodeSelectors.opener).on('click', function () {
            if( jQuery(nodeSelectors.container).is(':visible') ) {
                close()
            } else {
                open()
            }
        })

        // Toggle submenu
        // jQuery(nodeSelectors.container + ' .menu-item-has-children').on('click', function (e) {
        //     e.stopPropagation()
        //
        //     jQuery(this).toggleClass('menu-item-has-children--submenu-is-active')
        //
        //     let subMenu = jQuery(this).find(' > .sub-menu')
        //
        //     if( !subMenu.is(':visible') ) {
        //         e.preventDefault()
        //     }
        //
        //     subMenu.slideToggle()
        // })
    }

    // Mobile nav functions
    function open() {
        openNavTl.timeScale(1).play()
        openNavTl.restart()

        jQuery('body, html').addClass('u-mobile-nav-active-no-scroll')
        jQuery(nodeSelectors.opener).addClass('hamburger--active');
        // jQuery(nodeSelectors.container).fadeIn(250);
        jQuery(SiteHeader().nodeSelectors.container).addClass('site-header--mobile-nav-is-active')
    }

    function close() {
        closeNavTl.timeScale(1).play()
        closeNavTl.restart()

        jQuery('body, html').removeClass('u-mobile-nav-active-no-scroll')
        // jQuery(nodeSelectors.container).fadeOut(200);
        jQuery(nodeSelectors.opener).removeClass('hamburger--active');
        jQuery(SiteHeader().nodeSelectors.container).removeClass('site-header--mobile-nav-is-active')
    }

    return Object.freeze({
        init,
        close,
        open,
        nodeSelectors
    })
}